import { InputWithOptionsDriver } from '../InputWithOptions/InputWithOptions.driver';

export interface AutoCompleteDriver extends InputWithOptionsDriver {}
